<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('preInvoice.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('preInvoice.pageTitle'),
            href: '/pre-invoices'
          },
          {
            text: $t('show'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row form-group">
          <div class="col-md-6">
            <form class="form-horizontal">
              <fieldset>
                <legend>{{ $t('preInvoice.studentInfo') }}</legend>
                <div class="row">
                  <label class="col-md-3 col-form-label">{{
                    $t('preInvoice.cardNumber')
                  }}</label>
                  <div class="col-md-9">
                    <input
                      readonly
                      type="text"
                      class="form-control-plaintext"
                      :value="showData.student.card_number"
                    />
                  </div>
                </div>
                <div class="row">
                  <label class="col-md-3 col-form-label">{{
                    $t('preInvoice.studentName')
                  }}</label>
                  <div class="col-md-9">
                    <input
                      readonly
                      class="form-control-plaintext"
                      :value="showData.student.full_name_en"
                    />
                  </div>
                </div>
                <div class="row">
                  <label class="col-md-3 col-form-label">{{
                    $t('preInvoice.sex')
                  }}</label>
                  <div class="col-md-9">
                    <input
                      readonly
                      class="form-control-plaintext"
                      :value="showData.student.gender"
                    />
                  </div>
                </div>
                <div class="row">
                  <label class="col-md-3 col-form-label">{{
                    $t('preInvoice.dateOfBirth')
                  }}</label>
                  <div class="col-md-9">
                    <input
                      readonly
                      class="form-control-plaintext"
                      :value="showData.student.date_of_birth"
                    />
                  </div>
                </div>
                <div class="row">
                  <label class="col-md-3 col-form-label">{{
                    $t('preInvoice.phone')
                  }}</label>
                  <div class="col-md-9">
                    <input
                      readonly
                      class="form-control-plaintext"
                      :value="showData.student.phone"
                    />
                  </div>
                </div>
              </fieldset>
            </form>
          </div>
          <div class="col-md-6">
            <form class="form-horizontal">
              <fieldset>
                <legend>{{ $t('preInvoice.academic') }}</legend>
                <div class="row">
                  <label class="col-md-3 col-form-label">{{
                    $t('preInvoice.mainProgram')
                  }}</label>
                  <div class="col-md-9">
                    <input
                      readonly
                      class="form-control-plaintext"
                      :value="showData.main_program.acp_name_foreign"
                    />
                  </div>
                </div>
                <div class="row">
                  <label class="col-md-3 col-form-label">{{
                    $t('preInvoice.subProgram')
                  }}</label>
                  <div class="col-md-9">
                    <input
                      readonly
                      class="form-control-plaintext"
                      :value="showData.sub_program.acps_name_foreign"
                    />
                  </div>
                </div>
                <div class="row">
                  <label class="col-md-3 col-form-label">{{
                    $t('preInvoice.academicTermName')
                  }}</label>
                  <div class="col-md-9">
                    <input
                      readonly
                      class="form-control-plaintext"
                      :value="showData.academic_term.term_name"
                    />
                  </div>
                </div>
                <div class="row">
                  <label class="col-md-3 col-form-label">{{
                    $t('preInvoice.gradeName')
                  }}</label>
                  <div class="col-md-9">
                    <input
                      readonly
                      class="form-control-plaintext"
                      :value="showData.grade.grade_name_foreign"
                    />
                  </div>
                </div>
                <div class="row">
                  <label class="col-md-3 col-form-label">{{
                    $t('preInvoice.remark')
                  }}</label>
                  <div class="col-md-9">
                    <input
                      readonly
                      class="form-control-plaintext"
                      :value="showData.remark"
                    />
                  </div>
                </div>
              </fieldset>
            </form>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-md-12">
            <panel :title="$t('preInvoice.item')">
              <div class="overflow-auto">
                <div id="list-container">
                  <table
                    class="table ui-table ts-table"
                    style="min-width:1520px"
                  >
                    <thead>
                      <tr>
                        <th style="width:250px">
                          {{ $t('preInvoice.feeType') }}
                        </th>
                        <th style="width:250px">
                          {{ $t('preInvoice.feeName') }}
                        </th>
                        <th style="width:250px">
                          {{ $t('preInvoice.description') }}
                        </th>
                        <th style="width:250px">
                          {{ $t('preInvoice.dateFrom') }}
                        </th>
                        <th style="width:250px">
                          {{ $t('preInvoice.dateTo') }}
                        </th>
                        <th style="width:110px" class="text-center">
                          {{ $t('preInvoice.qty') }}
                        </th>
                        <th style="width:110px" class="text-center">
                          {{ $t('preInvoice.fee') }}
                        </th>
                        <th style="width:120px" class="text-center">
                          {{ $t('preInvoice.discount') }}
                        </th>
                        <th style="width:110px" class="text-center">
                          {{ $t('preInvoice.vat') }}
                        </th>
                        <th style="width:110px">
                          {{ $t('preInvoice.amount') }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in showData.pre_invoice_detail"
                        :key="index"
                      >
                        <td>{{ item.fee_type.fee_type_name }}</td>
                        <td>{{ item.fee_setup.fee_name_en }}</td>
                        <td>{{ item.fee_description }}</td>
                        <td>{{ item.fee_start_date }}</td>
                        <td>{{ item.fee_end_date }}</td>
                        <td class="text-center">{{ item.quantity }}</td>
                        <td class="text-center">{{ item.fee_amount }}</td>
                        <td class="text-center">{{ item.discount_rate }}</td>
                        <td class="text-center">{{ item.vat_rate }}</td>
                        <td class="text-right">{{ item.total_amount }}</td>
                      </tr>
                      <tr>
                        <td colspan="9" class="text-right">
                          <strong>{{ $t('preInvoice.total') }}</strong>
                        </td>
                        <td class="text-right">
                          <strong
                            ><u>{{ showData.total_amount }}</u></strong
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </panel>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-right">
            <ts-button @click="$router.push({ name: 'pre-invoice' })">{{
              $t('close')
            }}</ts-button>
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'preInvoiceShow',
  data() {
    return {}
  },
  created() {},
  computed: {
    ...mapState('preInvoice', ['showData'])
  }
}
</script>

<style lang="css" scoped>
#list-container {
  white-space: nowrap;
}
.table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 999;
}
.table > tbody > tr > td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border: none !important;
}
</style>
